const config= {
    mainUrl:process.env.REACT_APP_MAIN_API,
    baseUrl: process.env.REACT_APP_BASE_API,
    baseUrlCP: process.env.REACT_APP_BASE_CP_API,
    calculatorJsUrl: process.env.REACT_APP_CALCULATOR_WIDGET_INDEX_JS_URL,
    calculatorCssUrl: process.env.REACT_APP_CALCULATOR_WIDGET_INDEX_CSS_URL,
    appFunnelJsUrl: process.env.REACT_APP_QUESTIONNAIRE_WIDGET_INDEX_JS_URL,
    appFunnelCssUrl: process.env.REACT_APP_QUESTIONNAIRE_WIDGET_INDEX_CSS_URL,
    // chatbotJsUrl: process.env.REACT_APP_CHATBOT_WIDGET_INDEX_JS_URL,
    // chatbotCssUrl: process.env.REACT_APP_CHATBOT_WIDGET_INDEX_CSS_URL,
}
export default config 